// react
import React from 'react'
import { useState } from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

const DaaSClients = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div id="daas-clients-page">
      <Header
        title="DaaS Clients"
        actions={[
          {
            children: 'Create New DaaS Client',
            onClick: toggleModal,
          },
        ]}
      />

      <ListView
        columns={[
          {
            name: 'Name',
            key: 'name',
            link: `/daas-clients/:_id`,
            sortable: true,
          },
          {
            key: 'created_at',
            link: `/daas-clients/:id`,
            name: 'Created At',
          },
        ]}
        entities="daas-clients"
        fields={['name', 'created_at']}
        searchable={true}
        sort_dir={1}
        sort_key={'name'}
      />
      <If condition={modalOpen}>
        <Dialog close={toggleModal} open={modalOpen}>
          <NewEntityDialog
            close={toggleModal}
            entities="daas-clients"
            title="Enter a name for the new DaaS Client"
          />
        </Dialog>
      </If>
    </div>
  )
}

// export
export default DaaSClients
